import { render, staticRenderFns } from "./questionPaperEditPop.vue?vue&type=template&id=53222e05&scoped=true"
import script from "./questionPaperEditPop.vue?vue&type=script&lang=js"
export * from "./questionPaperEditPop.vue?vue&type=script&lang=js"
import style0 from "./questionPaperEditPop.vue?vue&type=style&index=0&id=53222e05&prod&lang=less"
import style1 from "./questionPaperEditPop.vue?vue&type=style&index=1&id=53222e05&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53222e05",
  null
  
)

export default component.exports